import React from 'react';
import LoanCalculatorKiwibank from './LoanCalculatorKiwibank';

const PersonalLoanCalculator = props => (
  // 'LoanCalculator' uses PL loan type by default
  // need to pass on all props
  <LoanCalculatorKiwibank {...props} />
);
export default PersonalLoanCalculator;
